<script lang="ts">
	import { cn, INPUT, LABEL } from '@papyria/ui';
	import Button from '@papyria/ui/Button.svelte';
	import * as m from '#lib/paraglide/messages.js';

	let sending = $state(false);

	function resetAfterBackNavigation(event: PageTransitionEvent) {
		if (event.persisted) {
			sending = false;
		}
	}
</script>

<svelte:window onpageshow={resetAfterBackNavigation} />

<form
	method="GET"
	action="/auth/sign-up"
	class="mt-auto flex max-w-xl flex-col gap-2 border-t border-rule pt-6"
	onsubmit={() => (sending = true)}
>
	<label for="email" class={LABEL}>{m.stealth_access_label()}</label>
	<div class="flex flex-col gap-2 sm:flex-row">
		<input
			id="email"
			name="email"
			type="email"
			required
			autocomplete="email"
			placeholder={m.stealth_access_placeholder()}
			class={cn(INPUT, 'min-w-0 flex-1')}
		/>
		<Button
			type="submit"
			variant="primary"
			disabled={sending}
			busy={sending}
			class="justify-center disabled:cursor-progress"
		>
			{sending ? m.stealth_access_sending() : m.stealth_access_submit()}
		</Button>
	</div>
</form>
